<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";

const columns = [
  { title: "№", width: "5%", scopedSlots: { customRender: "number" } },
  { title: "Müraciət mətni", width: "15%", dataIndex: "text" },
  { title: "Yerli icra hakimiyyəti orqanı", dataIndex: "executive.name", width: "15%" },
  { title: "Ünvan", scopedSlots: { customRender: "address" }, width: "13%" },
  { title: "İlkin müraciət tarixi", dataIndex: "appealDate", width: "10%" },
  { title: "Müraciət sayı", dataIndex: "appealCount", width: "7%" },
  { title: "", scopedSlots: { customRender: "actions" }, width: "5%" },
];

export default {
  name: "ResultProblemsList",
  data() {
    return {
      problemsList: [],
      loading: false,
      columns,
      pagination: { pageSize: 10, current: 1 },
      mylocale: { emptyText: "Məlumat yoxdur" },
    };
  },
  methods: {
    getResults() {
      this.loading = true;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "problems/" +
          this.$route.params.id +
          "/results",
      })
        .then((response) => {
          if (!response.data.error) {
            this.problemsList = response.data.data;
            const pagination = { ...this.pagination };
            pagination.total = this.problemsList.length;
            this.pagination = pagination;
          } else this.$message.error(response.data.error.message);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    goPage(record) {
      window.location.href = "/problems/" + record.id;
    },
  },
  created() {
    this.getResults();
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
